/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHeartbeat} from '@fortawesome/pro-duotone-svg-icons';

const HealthIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faHeartbeat} {...props} />
);

export default HealthIcon;
